import React from 'react'
import { Head } from '../../component'
import { CardEducation } from './components'
import { Route } from '../../config/router'
import { TrackPageViewed, useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { CheckoutPage, TrackingEvent } from '../../model'
import { useAppRouter, useApplePayEntryData } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { ApplePaylaterFlowType } from '../../flow/apple-paylater/model'

export const CardEducationPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const pageTitle = t('common:brandName')
  const applePayEntryData = useApplePayEntryData()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const flowType = applePayEntryData?.flowType

  const isInstoreOrWalletProvisioning = flowType === ApplePaylaterFlowType.InStore || flowType === ApplePaylaterFlowType.WalletProvisioning

  const handleContinue = (): void => {
    logEvent(TrackingEvent.PRESSED_APPLE_PAYLATER_CARD_EDUCATION_CONTINUE_BUTTON, { flowType })
    const nextRoute = isInstoreOrWalletProvisioning ? Route.ADJUST_AMOUNT : Route.APPLE_PAYLATER_INITIALISE
    router.replaceQuery({ pathname: nextRoute, query: router.query })
  }

  return (
    <>
      <Head title={pageTitle} />
      <CardEducation onContinue={handleContinue} />
      <TrackPageViewed eventProperties={{ flowType }} />
    </>
  )
}
